import { h } from '@stencil/core';
import DefaultIcon from './icons/default.svg';
import { knownTypes } from './constants';
export class PesDocumentIcon {
  constructor() {
    this.getIconByType = (type) => {
      if (type.toLowerCase() in knownTypes) {
        return knownTypes[type.toLowerCase()];
      }
      return DefaultIcon;
    };
    this.type = undefined;
  }
  render() {
    return h("span", { class: "pes-document-icon", innerHTML: this.getIconByType(this.type) });
  }
  static get is() { return "pes-document-icon"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-document-icon.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-document-icon.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Type of icon. Supports lots of filetypes. If some unknown type given default icon will be used."
        },
        "attribute": "type",
        "reflect": false
      }
    };
  }
}
